import styles from "./UserAddEdit.module.css";
import {
	Button,
	TextField,
	Select,
	MenuItem,
	FormControlLabel,
	Checkbox,
	InputLabel,
	FormControl,
} from "@mui/material";
import { useSnackbar } from "notistack";
import Icon from "@mdi/react";
import { mdiChevronLeft } from "@mdi/js";

// react
import React, { useState, useEffect } from "react";
import { useParams, Redirect } from "react-router-dom";

// tools
import Services from "tools/Services";

export default function AddUser() {
	const { enqueueSnackbar } = useSnackbar();
	const [user, setUser] = useState({ userName: "", weight: 10, active: true, roles: "User" });
	const [redirect, setRedirect] = useState(false);
	const [error, setError] = useState(false);
	const { id } = useParams();

	useEffect(() => {
		if (id !== "new") loadUser(id);
	}, [id]);

	const loadUser = async (id) => {
		// GET
		let res = await Services.get("/User/getUser/" + id);

		// ERROR
		if (res.status !== 200) {
			console.error(res);
			return;
		}

		// SUCCESS
		setUser(res.data);
	};

	const handleChangeUserName = (e) => {
		setUser({ ...user, userName: e.target.value });
		setError(false);
	};
	const handleChangeWeight = (e) => {
		setUser({ ...user, weight: e.target.value });
		setError(false);
	};
	const handleChangeActive = (e) => {
		setUser({ ...user, active: e.target.checked });
	};
	const handleChangeRole = (e) => {
		setUser({ ...user, roles: e.target.value });
	};
	const handleClickSave = async (e) => {
		e.preventDefault();

		if (user.userName === "" || user.weight === "") {
			setError(true);
			return;
		}
		// PUT
		const data = user;
		let res = await Services.put("/User", data);

		// TODO: handle error when the user exist and when user puts letters in weight field
		// ERROR
		if (res.status !== 200) {
			console.error(res);
			enqueueSnackbar(res.error, {
				variant: "error",
			});
			return;
		}

		// SUCCESS
		setRedirect(true);
		enqueueSnackbar("Changes saved", {
			variant: "success",
		});
	};

	return (
		<div className={styles.container}>
			{redirect && <Redirect to="/Users" />}
			<Button variant="outlined" className={styles.button} onClick={() => setRedirect(true)}>
				<Icon path={mdiChevronLeft} size={1} /> Back
			</Button>
			<form onSubmit={handleClickSave} className={styles.form}>
				{id === "new" ? (
					<div className={styles.adding}>New User</div>
				) : (
					<div className={styles.editing}>Edit User</div>
				)}
				<TextField
					variant="standard"
					label="Username"
					name="userName"
					value={user.userName}
					error={error}
					onChange={handleChangeUserName}
				/>
				<TextField
					variant="standard"
					label="Weight (number)"
					name="weight"
					value={user.weight}
					error={error}
					onChange={handleChangeWeight}
				/>
				<FormControlLabel
					control={<Checkbox checked={user.active} onChange={handleChangeActive} />}
					label="Active"
				/>
				<FormControl>
					<InputLabel id="demo-label">Role</InputLabel>
					<Select labelId="demo-label" id="demo" label="Role" value={user.roles} onChange={handleChangeRole}>
						<MenuItem value={"User"}>User</MenuItem>
						<MenuItem value={"Admin"}>Admin</MenuItem>
					</Select>
				</FormControl>
				<div className={styles.formButtons}>
					<Button variant="outlined" onClick={() => setRedirect(true)}>
						Cancel
					</Button>
					<Button type="submit" variant="contained" sx={{ color: "#FFD" }}>
						Save
					</Button>
				</div>
				{error && <div className={styles.error}>Please don't leave fields empty 😢</div>}
			</form>
		</div>
	);
}
